import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { apiFetch } from '../services/api';

const KontekstLogowania = createContext(null);

export function DostawcaLogowania({ children }) {
  const [uzytkownik, setUzytkownik] = useState(() => {
    const raw = localStorage.getItem('uzytkownik');
    return raw ? JSON.parse(raw) : null;
  });
  const [ladowanie, setLadowanie] = useState(true);

  useEffect(() => {
    const wylogujPo401 = () => setUzytkownik(null);
    window.addEventListener('auth:logout', wylogujPo401);
    const sprawdz = async () => {
      if (!localStorage.getItem('token')) { setLadowanie(false); return; }
      try {
        const me = await apiFetch('/logowanie/me');
        setUzytkownik(me);
        localStorage.setItem('uzytkownik', JSON.stringify(me));
      } catch {
        localStorage.removeItem('token'); localStorage.removeItem('uzytkownik'); setUzytkownik(null);
      } finally { setLadowanie(false); }
    };
    sprawdz();
    return () => window.removeEventListener('auth:logout', wylogujPo401);
  }, []);

  const zaloguj = async (login, haslo) => {
    const data = await apiFetch('/logowanie', { method:'POST', body:JSON.stringify({login,haslo}) });
    if (data.wymagana_zmiana_hasla) return data;
    localStorage.setItem('token', data.token);
    localStorage.setItem('uzytkownik', JSON.stringify(data.uzytkownik));
    setUzytkownik(data.uzytkownik);
    return data;
  };

  const wyloguj = useCallback(() => {
    localStorage.removeItem('token'); localStorage.removeItem('uzytkownik'); setUzytkownik(null);
  }, []);

  const maUprawnienie = useCallback((kod) =>
    !!uzytkownik?.uprawnienia?.includes(kod) || uzytkownik?.rola === 'ADMIN', [uzytkownik]);

  const value = useMemo(() => ({uzytkownik,ladowanie,zaloguj,wyloguj,maUprawnienie}),
    [uzytkownik,ladowanie,wyloguj,maUprawnienie]);

  return <KontekstLogowania.Provider value={value}>{children}</KontekstLogowania.Provider>;
}

export const useLogowanie = () => useContext(KontekstLogowania);
